"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20Setup = void 0;
const Game_1 = require("./Game");
const Z20Entity_1 = require("./Z20Entity");
const Z20Tool_1 = require("./Z20Tool");
class Z20Setup {
    constructor(random, maxLAKs, config) {
        this.tools = [];
        this.entities = [];
        this.levels = config.levels;
        let toolArray = Array.from(new Array(Game_1.game.toolCount), (x, i) => i + 1);
        for (let i = 0; i < maxLAKs; i++) {
            this.tools.push(new Z20Tool_1.default(i, `tool${toolArray[i]}`));
        }
        let npcArray = Array.from(new Array(Game_1.game.npcCount), (x, i) => i + 1);
        if (config.shuffleNpcsAndTools) {
            random.shuffleArray(npcArray);
            random.shuffleArray(toolArray);
        }
        this.trophy = new Z20Entity_1.default(1000, { wins: true, sprite: 'trophy' });
        this.player = new Z20Entity_1.default(2000, { player: true, sprite: `npc${npcArray[0]}` });
        for (let i = 0; i < maxLAKs; i++) {
            this.entities.push(new Z20Entity_1.default(i * 2, { gives: this.tools[i], sprite: `npc${npcArray[i * 2 + 1]}` }));
            this.entities.push(new Z20Entity_1.default(i * 2 + 1, { kills: true, weakness: this.tools[i], sprite: `npc${npcArray[i * 2 + 2]}` }));
        }
        this.random = random;
    }
    static defaultLevels() {
        return [
            {
                size: { x: 5, y: 5 },
                minDeadEnds: 3,
                // maxSteps: 20,
                minLAKs: 1,
                maxLAKs: 2,
                bonusConnectionChance: 0.3,
                oneOffConnectionChance: 0.2,
            }, {
                size: { x: 7, y: 7 },
                minDeadEnds: 3,
                minLAKs: 3,
                maxLAKs: 3,
                bonusConnectionChance: 0.4,
                oneOffConnectionChance: 0.2,
                redHerringChance: 0.1,
            }, {
                size: { x: 7, y: 9 },
                minDeadEnds: 3,
                minLAKs: 4,
                maxLAKs: 4,
                bonusConnectionChance: 0.4,
                oneOffConnectionChance: 0.25,
                redHerringChance: 0.25,
            }, {
                size: { x: 9, y: 9 },
                minDeadEnds: 3,
                minLAKs: 5,
                maxLAKs: 5,
                bonusConnectionChance: 0.5,
                oneOffConnectionChance: 0.25,
                extraGroupChance: .05,
                redHerringChance: 0.5,
            }, {
                size: { x: 9, y: 11 },
                minDeadEnds: 8,
                minLAKs: 6,
                maxLAKs: 6,
                bonusConnectionChance: 0.5,
                oneOffConnectionChance: 0.25,
                extraGroupChance: 0.3,
                redHerringChance: true,
            }, {
                size: { x: 9, y: 11 },
                minDeadEnds: 8,
                straightBias: 0.3,
                minLAKs: 6,
                maxLAKs: 6,
                bonusConnectionChance: 0.45,
                oneOffConnectionChance: 0.22,
                redHerringChance: true,
                extraGroupChance: 0.3,
            }
        ];
    }
    static prototypeLevels() {
        return [
            {
                size: { x: 5, y: 5 },
                minDeadEnds: 3,
                // maxSteps: 20,
                minLAKs: 1,
                maxLAKs: 6,
            }, {
                size: { x: 7, y: 7 },
                minDeadEnds: 3,
                minLAKs: 3,
                maxLAKs: 6,
            }, {
                size: { x: 7, y: 9 },
                minDeadEnds: 3,
                minLAKs: 4,
                maxLAKs: 6,
            }, {
                size: { x: 9, y: 9 },
                minDeadEnds: 3,
                minLAKs: 5,
                maxLAKs: 6,
            }, {
                size: { x: 9, y: 11 },
                minDeadEnds: 8,
                minLAKs: 6,
                maxLAKs: 6,
            }
        ];
    }
}
exports.Z20Setup = Z20Setup;
